import React from 'react';
import { defaultLang } from './default';

export const LanguageContext = React.createContext(defaultLang);